const EARLY_RETAKE_MONTHS = 3

export const useCertificates = defineStore('certificates', () => {
  const { $api } = useNuxtApp()
  const store = useBaseStore('certificates')

  function open (id) {
    return $api.get(`/certificates/${id}/open`)
  }

  function isEarlyRetakePeriod (expiryDateStr) {
    if (!expiryDateStr) return false
    const expiryDate = new Date(expiryDateStr)
    if (isNaN(expiryDate)) return false

    const now = new Date()
    const diffInMonths =
      (expiryDate.getFullYear() - now.getFullYear()) * 12 +
      (expiryDate.getMonth() - now.getMonth())

    return diffInMonths < EARLY_RETAKE_MONTHS && expiryDate > now
  }

  return {
    ...store,
    open,

    isEarlyRetakePeriod,
    EARLY_RETAKE_MONTHS
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCertificates, import.meta.hot))
}
